import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import appSettingsServices from '@src/services/appSettings.services';

export const parameterUpdate = createAsyncThunk(
  'admin/parameterUpdate',
  async ({ body }, { rejectWithValue }) => {
    try {
      const result = await appSettingsServices.parameterUpdate(body);
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const parameterGetPagedList = createAsyncThunk(
  'admin/parameterGetPagedList',
  async ({ body, pageNumber, pageSize }, { rejectWithValue }) => {
    try {
      const result = await appSettingsServices.getPagedList({ body, pageNumber, pageSize });
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  parameterList: [],
  tableProperty: {
    currentPage: 1,
    page: 1,
    pageSize: 10,
    totalCount: 0,
  },
  filterObject: {
    body: [],
    pageNumber: 1,
    pageSize: 10,
  },
};

export const managementAppSettingsSlice = createSlice({
  name: 'admin/managementAppSettings',
  initialState,
  reducers: {
    resetFilterObject: (state) => {
      state.filterObject = {
        body: [],
        pageNumber: 1,
        pageSize: 10,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(parameterGetPagedList.fulfilled, (state, action) => {
      state.parameterList = action?.payload?.data?.items || [];
      state.tableProperty = action?.payload?.data?.pagedProperty || initialState?.tableProperty;
    });
  },
});
export const { resetFilterObject } = managementAppSettingsSlice.actions;
